import clsx from "clsx";

type Tone = "success" | "warn" | "info" | "danger" | "neutral";

const COLORS: Record<Tone, { dot: string; halo: string }> = {
  success: { dot: "bg-emerald-400", halo: "bg-emerald-400/40" },
  warn: { dot: "bg-amber-400", halo: "bg-amber-400/40" },
  info: { dot: "bg-sky-400", halo: "bg-sky-400/40" },
  danger: { dot: "bg-rose-400", halo: "bg-rose-400/40" },
  neutral: { dot: "bg-slate-400", halo: "bg-slate-400/40" },
};

interface StatusDotProps {
  tone: Tone;
  /** When true, renders a soft pulsing halo behind the dot. */
  pulse?: boolean;
  className?: string;
}

/**
 * Tiny coloured dot used inside status pills and chips. The optional pulsing
 * halo signals "live" / "in progress" states (e.g. account verifying, campaign
 * actively running) without taking up extra room.
 */
export default function StatusDot({ tone, pulse, className }: StatusDotProps): JSX.Element {
  const c = COLORS[tone];
  return (
    <span className={clsx("relative inline-flex h-2 w-2 shrink-0", className)} aria-hidden="true">
      {pulse && (
        <span className={clsx("absolute inset-0 animate-ping rounded-full", c.halo)} />
      )}
      <span className={clsx("relative inline-block h-2 w-2 rounded-full", c.dot)} />
    </span>
  );
}
